<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data () {
    return {};
  },
  components: {
  },
  methods: {

  }

};
</script>
<style lang="scss">
:focus {
  outline: none;
}
body{
  font-size: 14px;
  overflow-y: hidden;
}
.el-loading-spinner .path{
  stroke:#fff;
}
.el-loading-mask{
  background: rgba(0, 0, 0, 0.51);
}
.el-input__suffix-inner .el-input__icon{
  line-height:0 ;
}
.el-input-number .el-input__inner{
  text-align: left;
}
.footer,.header{
  font-family: Arial, '微软雅黑', sans-serif;
}
.header {
  border-bottom: 1px solid #f3f3f3;
}
#app{
  width: 100%;
  height: 100%;
}

.call-top-san {
  margin-top: -6px;
}

html,body{
  width: 100%;
  height: 100%;
}

</style>
